import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'
import './Views/PartialViews/LanguageSelector/styles.css'
import './Components/UserIsActiveComponent/styles.css'

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx